import { profile, experience, education, skills } from '@/data';

/**
 * schema.org Person, emitted as JSON-LD.
 *
 * Search engines and some recruiter tools read this to build a structured
 * profile — it is the machine-readable counterpart to the page's prose.
 *
 * `telephone` is deliberately omitted: it is in the downloadable resume files
 * only, and putting it in JSON-LD would publish it to every crawler that reads
 * structured data, defeating the point (PLAN.md §11.5).
 */
export function personSchema(siteUrl: string) {
  const current = experience.find((role) => role.endDate === null);

  return {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: profile.name,
    jobTitle: profile.title,
    email: `mailto:${profile.email}`,
    url: siteUrl,
    description: profile.summary[0],
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Houston',
      addressRegion: 'TX',
      addressCountry: 'US',
    },
    sameAs: [profile.links.linkedin, profile.links.github],
    knowsAbout: skills.flatMap((group) => group.skills).slice(0, 30),
    alumniOf: education.map((entry) => ({
      '@type': 'CollegeOrUniversity',
      name: entry.institution,
    })),
    ...(current ? { worksFor: { '@type': 'Organization', name: current.company } } : {}),
  };
}
